import { AppComponent as CoreAppComponent, M3LoaderComponent, ModuleName } from '@macq/m3-front-lib-core';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    imports: [CoreAppComponent, RouterOutlet, M3LoaderComponent],
    standalone: true,
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
    isLoaded = false;
    core = ModuleName.CORE;
}
